import mock from "../mock";

const productConfig = {
  sections: [
    {
      section_id: "general-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "general-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [],
        },
      ],
    },
    {
      section_id: "general-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
          ],
        },
      ],
    },
    {
      section_id: "car-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Car Brand",
              placeholder: "Car Brand",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "100",
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "transmission",
              ui_type: "ui_choose_hor",
              header: "Transmission Type",
              placeholder: "Transmission Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 10,
              choices: [
                ["auto", "Automatic"],
                ["manual", "Manual"],
              ],
            },
            {
              key: "engine_type",
              ui_type: "ui_choose_hor",
              header: "Engine Type",
              placeholder: "Engine Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 11,
              choices: [
                ["benzine", "Benzine"],
                ["diesel", "Diesel"],
                ["hybrid", "Hybrid"],
              ],
            },
            {
              key: "color",
              ui_type: "ui_choose",
              header: "Car Color",
              placeholder: "Car Color",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "15",
              min_len: null,
              required: true,
              order: 12,
              choices: [
                ["black", "Black"],
                ["blue", "Blue"],
                ["bronze", "Bronze"],
                ["brown", "Brown"],
                ["burgundy", "Burgundy"],
                ["champagne", "Champagne"],
                ["darkblue", "Dark Blue"],
                ["gold", "Gold"],
                ["green", "Green"],
                ["grey", "Grey"],
                ["kaki1d9", "Kaki (1D9)"],
                ["orange", "Orange"],
                ["pencil", "Pencil"],
                ["red", "Red"],
                ["silver", "Silver"],
                ["skyblue", "Sky Blue"],
                ["white", "White"],
                ["yellow", "Yellow"],
              ],
            },
            {
              key: "milage",
              ui_type: "ui_input_num",
              header: "Set Milage",
              placeholder: "Milage",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 13,
              choices: null,
            },
            {
              key: "year",
              ui_type: "ui_input_num",
              header: "Production Year",
              placeholder: "Year",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 14,
              choices: null,
            },
            {
              key: "product_for",
              ui_type: "ui_choose_hor",
              header: "Product For",
              placeholder: "Product For",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 15,
              choices: [
                ["rental", "For Rental"],
                ["sale", "For Sale"],
              ],
            },
            {
              key: "engine_size",
              ui_type: "ui_choose",
              header: "Engine Size",
              placeholder: "Engine Size",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 16,
              choices: [
                [100, "1100"],
                [800, "800"],
                [1100, "1100"],
                [1300, "1300"],
                [1600, "1600"],
                [2000, "2000"],
                [2500, "2500"],
                [3000, "3000"],
                [3500, "3500"],
                [4500, "4500"],
                [5300, "5300"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "car-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "brand",
              ui_type: "ui_key_value",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "transmission",
              ui_type: "ui_key_value",
              header: "Transmission",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "engine_type",
              ui_type: "ui_key_value",
              header: "Engine Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "color",
              ui_type: "ui_key_value",
              header: "Color",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "milage",
              ui_type: "ui_key_value",
              header: "Set Milage",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "year",
              ui_type: "ui_key_value",
              header: "Production Year",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "product_for",
              ui_type: "ui_key_value",
              header: "Product For",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "engine_size",
              ui_type: "ui_key_value",
              header: "Engine Size",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "car-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_num",
              header: "Start Price",
              placeholder: "Start Price",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_num",
              header: "End Price",
              placeholder: "End Price",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "transmission",
              ui_type: "ui_choose_hor",
              header: "Transmission",
              placeholder: "Transmission",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [
                ["auto", "Automatic"],
                ["manual", "Manual"],
              ],
            },
            {
              key: "engine_type",
              ui_type: "ui_choose_hor",
              header: "Engine Type",
              placeholder: "Engine Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [
                ["benzine", "Benzine"],
                ["diesel", "Diesel"],
                ["hybrid", "Hybrid"],
              ],
            },
            {
              key: "color",
              ui_type: "ui_choose",
              header: "Color",
              placeholder: "Color of the car",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 5,
              choices: [
                ["black", "Black"],
                ["blue", "Blue"],
                ["bronze", "Bronze"],
                ["brown", "Brown"],
                ["burgundy", "Burgundy"],
                ["champagne", "Champagne"],
                ["darkblue", "Dark Blue"],
                ["gold", "Gold"],
                ["green", "Green"],
                ["grey", "Grey"],
                ["kaki1d9", "Kaki (1D9)"],
                ["orange", "Orange"],
                ["pencil", "Pencil"],
                ["red", "Red"],
                ["silver", "Silver"],
                ["skyblue", "Sky Blue"],
                ["white", "White"],
                ["yellow", "Yellow"],
              ],
            },
            {
              key: "milage",
              ui_type: "ui_input_num",
              header: "Milage",
              placeholder: "Milage",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 6,
              choices: [],
            },
            {
              key: "year",
              ui_type: "ui_input_str",
              header: "Year",
              placeholder: "Year",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 7,
              choices: [],
            },
            {
              key: "product_for",
              ui_type: "ui_choose_hor",
              header: "Product For",
              placeholder: "Car listing For",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 8,
              choices: [
                ["rental", "For Rental"],
                ["sale", "For Sale"],
              ],
            },
            {
              key: "engine_size",
              ui_type: "ui_choose",
              header: "Engine Size",
              placeholder: "Size of the car engine",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 9,
              choices: [
                [100, "1100"],
                [800, "800"],
                [1100, "1100"],
                [1300, "1300"],
                [1600, "1600"],
                [2000, "2000"],
                [2500, "2500"],
                [3000, "3000"],
                [3500, "3500"],
                [4500, "4500"],
                [5300, "5300"],
              ],
            },
          ],
        },
      ],
    },
    {
      section_id: "house-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "no_bedrooms",
              ui_type: "ui_input_num",
              header: "No Bedrooms",
              placeholder: "No Bedrooms",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "no_bathrooms",
              ui_type: "ui_input_num",
              header: "No Bathrooms",
              placeholder: "No Bathrooms",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 10,
              choices: null,
            },
            {
              key: "house_type",
              ui_type: "ui_input_str",
              header: "House Type",
              placeholder: "House Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 11,
              choices: null,
            },
            {
              key: "area",
              ui_type: "ui_input_num",
              header: "Area",
              placeholder: "Area",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 12,
              choices: null,
            },
            {
              key: "product_for",
              ui_type: "ui_choose_hor",
              header: "Product For",
              placeholder: "Product For",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 13,
              choices: [
                ["rental", "For Rental"],
                ["sale", "For Sale"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "house-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "address",
              ui_type: "ui_key_value",
              header: "Address",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "no_bedrooms",
              ui_type: "ui_key_value",
              header: "No Bedrooms",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "no_bathrooms",
              ui_type: "ui_key_value",
              header: "No Bathrooms",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "house_type",
              ui_type: "ui_key_value",
              header: "House Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "product_for",
              ui_type: "ui_key_value",
              header: "Product For",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "house-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "product_for",
              ui_type: "ui_choose",
              header: "Product For",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [
                ["rental", "For Rental"],
                ["sale", "For Sale"],
              ],
            },
            {
              key: "no_bedrooms",
              ui_type: "ui_input_num",
              header: "No Bedrooms",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [],
            },
            {
              key: "no_bathrooms",
              ui_type: "ui_input_num",
              header: "No Bathrooms",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 5,
              choices: [],
            },
            {
              key: "start_area",
              ui_type: "ui_input_num",
              header: "Start Area",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 6,
              choices: [],
            },
            {
              key: "end_area",
              ui_type: "ui_input_num",
              header: "End Area",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 7,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "electronics-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: "Brand",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "ram",
              ui_type: "ui_input_str",
              header: "Ram",
              placeholder: "Ram",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 10,
              choices: null,
            },
            {
              key: "storage",
              ui_type: "ui_input_str",
              header: "Storage",
              placeholder: "Storage",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 11,
              choices: null,
            },
            {
              key: "mode",
              ui_type: "ui_input_str",
              header: "Mode",
              placeholder: "Mode",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 12,
              choices: null,
            },
            {
              key: "electronics_type",
              ui_type: "ui_choose",
              header: "Electronics Type",
              placeholder: "Electronics Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "15",
              min_len: null,
              required: true,
              order: 13,
              choices: [
                ["iphone", "Iphone"],
                ["android", "Android"],
                ["tablet", "Tablet"],
                ["laptop", "laptop"],
                ["tv", "Tv and Entertaiments"],
                ["speaker", "Earphone and Speakers"],
                ["accessory", "accessories"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "electronics-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "brand",
              ui_type: "ui_key_value",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "ram",
              ui_type: "ui_key_value",
              header: "Ram",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "storage",
              ui_type: "ui_key_value",
              header: "Storage",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "mode",
              ui_type: "ui_key_value",
              header: "Mode",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "electronics_type",
              ui_type: "ui_key_value",
              header: "Electronics Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "electronics-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "electronics_type",
              ui_type: "ui_input_str",
              header: "Electronics Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [
                ["iphone", "Iphone"],
                ["android", "Android"],
                ["tablet", "Tablet"],
                ["laptop", "laptop"],
                ["tv", "Tv and Entertaiments"],
                ["speaker", "Earphone and Speakers"],
                ["accessory", "accessories"],
              ],
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "fashion-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: "Brand",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "size",
              ui_type: "ui_input_str",
              header: "Size",
              placeholder: "Size",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 10,
              choices: null,
            },
            {
              key: "material",
              ui_type: "ui_input_str",
              header: "Material",
              placeholder: "Material",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 11,
              choices: null,
            },
            {
              key: "gender",
              ui_type: "ui_choose_hor",
              header: "Gender",
              placeholder: "Gender",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 12,
              choices: [
                ["both", "Both"],
                ["male", "Male"],
                ["female", "Female"],
              ],
            },
            {
              key: "age_group",
              ui_type: "ui_choose_hor",
              header: "Age Group",
              placeholder: "Age Group",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "10",
              min_len: null,
              required: true,
              order: 13,
              choices: [
                ["kid", "Kids"],
                ["adult", "Adults"],
              ],
            },
            {
              key: "fashion_type",
              ui_type: "ui_choose",
              header: "Fashion Type",
              placeholder: "Fashion Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "15",
              min_len: null,
              required: true,
              order: 14,
              choices: [
                ["pant", "Pants , Jeans and shorts"],
                ["dress_skirt", "Dress and Skirts"],
                ["shoes", "Shoes"],
                ["watch", "Watch"],
                ["bag", "Bags"],
                ["wallet", "Wallet"],
                ["accessory", "Accessories"],
                ["jewellery", "Jewellery"],
                ["toy", "Toys"],
                ["other", "Others"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "fashion-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "brand",
              ui_type: "ui_key_value",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "size",
              ui_type: "ui_key_value",
              header: "Size",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "material",
              ui_type: "ui_key_value",
              header: "Material",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "gender",
              ui_type: "ui_key_value",
              header: "Gender",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "age_group",
              ui_type: "ui_key_value",
              header: "Age Group",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "fashion_type",
              ui_type: "ui_key_value",
              header: "Fashion Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "fashion-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "fashion_type",
              ui_type: "ui_choose",
              header: "Fashion Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [
                ["pant", "Pants , Jeans and shorts"],
                ["dress_skirt", "Dress and Skirts"],
                ["shoes", "Shoes"],
                ["watch", "Watch"],
                ["bag", "Bags"],
                ["wallet", "Wallet"],
                ["accessory", "Accessories"],
                ["jewellery", "Jewellery"],
                ["toy", "Toys"],
                ["other", "Others"],
              ],
            },
            {
              key: "age_group",
              ui_type: "ui_choose_hor",
              header: "Age Group",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [
                ["kid", "Kids"],
                ["adult", "Adults"],
              ],
            },
            {
              key: "gender",
              ui_type: "ui_choose_hor",
              header: "Gender",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 5,
              choices: [
                ["both", "Both"],
                ["male", "Male"],
                ["female", "Female"],
              ],
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 6,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "fooddrink-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "fooddrink-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [],
        },
      ],
    },
    {
      section_id: "fooddrink-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
          ],
        },
      ],
    },
    {
      section_id: "furniture-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: "Brand",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "furniture_type",
              ui_type: "ui_choose",
              header: "Furniture Type",
              placeholder: "Furniture Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "15",
              min_len: null,
              required: true,
              order: 10,
              choices: [
                ["bed_matress", "Bed & Matress"],
                ["sofa", "Sofa"],
                ["table", "Table"],
                ["chair", "Chair"],
                ["decor", "Home Decor"],
                ["shelves", "Shelves and Drawers"],
                ["others", "Others"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "furniture-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "brand",
              ui_type: "ui_key_value",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "furniture_type",
              ui_type: "ui_key_value",
              header: "Furniture Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "furniture-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [],
            },
            {
              key: "furniture_type",
              ui_type: "ui_choose",
              header: "Furniture Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [
                ["bed_matress", "Bed & Matress"],
                ["sofa", "Sofa"],
                ["table", "Table"],
                ["chair", "Chair"],
                ["decor", "Home Decor"],
                ["shelves", "Shelves and Drawers"],
                ["others", "Others"],
              ],
            },
          ],
        },
      ],
    },
    {
      section_id: "healthbuety-create",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: "Pictures",
              placeholder: "Pictures",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "5",
              min_len: "1",
              required: true,
              order: 8,
              choices: null,
            },
          ],
        },
        {
          key: "title_price",
          header: "Title & Price",
          description: null,
          info:
            "Provide title and price of the product. A descriptive product title is recommended.",
          order: "20",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_str",
              header: "Title",
              placeholder: "Title",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 0,
              choices: null,
            },
            {
              key: "price",
              ui_type: "ui_input_num",
              header: "Price",
              placeholder: "Price",
              prefix: "ETB",
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: true,
              order: 4,
              choices: null,
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: "Usage Condition",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "12",
              min_len: null,
              required: true,
              order: 5,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "address",
              ui_type: "ui_input_str",
              header: "Address",
              placeholder: "Address",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: false,
              order: 3,
              choices: null,
            },
            {
              key: "instock",
              ui_type: "ui_radio_box",
              header: "Instock",
              placeholder: "Instock",
              prefix: null,
              suffix: null,
              default: "True",
              max_len: null,
              min_len: null,
              required: true,
              order: 7,
              choices: null,
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: "Brand",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "150",
              min_len: null,
              required: true,
              order: 9,
              choices: null,
            },
            {
              key: "healthbuety_type",
              ui_type: "ui_choose",
              header: "Healthbuety Type",
              placeholder: "Healthbuety Type",
              prefix: null,
              suffix: null,
              default: null,
              max_len: "15",
              min_len: null,
              required: true,
              order: 10,
              choices: [
                ["makeup", "Makeup"],
                ["hair_care", "Hair Care"],
                ["skin_care", "Face and Skin Care"],
                ["bath_body", "Bath and Body"],
                ["perfume", "Perfumes and Deodorants"],
                ["hand_foot_care", "Hand and Foot Care"],
                ["others", "Others"],
              ],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: "Any Other Detail Informatin",
              placeholder: "Description",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 6,
              choices: null,
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: "Latitude",
              placeholder: "Latitude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 1,
              choices: null,
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: "Longtude",
              placeholder: "Longtude",
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: false,
              order: 2,
              choices: null,
            },
          ],
        },
      ],
    },
    {
      section_id: "healthbuety-detail",
      fieldsets: [
        {
          key: "product_pictures",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: null,
          more: null,
          ui_type: "ui_picture",
          field_s: [
            {
              key: "pictures",
              ui_type: "ui_picture_mul",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_title",
          header: null,
          description: null,
          info: null,
          order: "20",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "title",
              ui_type: "ui_input_title",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_price",
          header: null,
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "price",
              ui_type: "ui_input_price",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_description",
          header: "Product Description",
          description: null,
          info: null,
          order: "40",
          remote: null,
          more: null,
          ui_type: "ui_header_body",
          field_s: [
            {
              key: "description",
              ui_type: "ui_input_str",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "location",
          header: "Product Location",
          description: null,
          info: null,
          order: "50",
          remote: null,
          more: null,
          ui_type: "ui_location",
          field_s: [
            {
              key: "latitude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "longtude",
              ui_type: "ui_input_loc",
              header: null,
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
        {
          key: "product_detail",
          header: "Product Detail",
          description: null,
          info: null,
          order: "60",
          remote: null,
          more: null,
          ui_type: "ui_table",
          field_s: [
            {
              key: "brand",
              ui_type: "ui_key_value",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "product_type",
              ui_type: "ui_key_value",
              header: "Product Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
          ],
        },
      ],
    },
    {
      section_id: "healthbuety-filter",
      fieldsets: [
        {
          key: "filter_fieldset",
          header: null,
          description: null,
          info: null,
          order: "0",
          remote: null,
          more: null,
          ui_type: null,
          field_s: [
            {
              key: "start_price",
              ui_type: "ui_input_str",
              header: "Start Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 0,
              choices: [],
            },
            {
              key: "end_price",
              ui_type: "ui_input_str",
              header: "End Price",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 1,
              choices: [],
            },
            {
              key: "usage_condition",
              ui_type: "ui_choose_hor",
              header: "Usage Condition",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 2,
              choices: [
                ["new", "New"],
                ["slightlyused", "Slightly Used"],
                ["old", "Old"],
              ],
            },
            {
              key: "brand",
              ui_type: "ui_input_str",
              header: "Brand",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 3,
              choices: [],
            },
            {
              key: "healthbuety_type",
              ui_type: "ui_input_str",
              header: "Healthbuety Type",
              placeholder: null,
              prefix: null,
              suffix: null,
              default: null,
              max_len: null,
              min_len: null,
              required: null,
              order: 4,
              choices: [
                ["makeup", "Makeup"],
                ["hair_care", "Hair Care"],
                ["skin_care", "Face and Skin Care"],
                ["bath_body", "Bath and Body"],
                ["perfume", "Perfumes and Deodorants"],
                ["hand_foot_care", "Hand and Foot Care"],
                ["others", "Others"],
              ],
            },
          ],
        },
      ],
    },
    {
      section_id: "grandshop-front",
      fieldsets: [
        {
          key: "ui_collection_banner",
          header: null,
          description: null,
          info: null,
          order: "10",
          remote: "http://104.248.163.118:8000/grandshop/product-collections/",
          more: null,
          ui_type: "ui_collection_banner",
          field_s: [],
        },
        {
          key: "featured_shops",
          header: "Featured Shops",
          description: null,
          info: null,
          order: "20",
          remote: "http://104.248.163.118:8000/grandshop/featured.shops/",
          more: "grandshop-featured-instashops",
          ui_type: "ui_shop_horizontal",
          field_s: [],
        },
        {
          key: "ui_business",
          header: "Explore By Businesses",
          description: null,
          info: null,
          order: "30",
          remote: null,
          more: null,
          ui_type: "ui_business",
          field_s: [],
        },
        {
          key: "product_near_you",
          header: "Nearby Products",
          description: null,
          info: null,
          order: "40",
          remote: "http://104.248.163.118:8000/grandshop/nearby.products/",
          more: null,
          ui_type: "ui_product_horizontal",
          field_s: [],
        },
        {
          key: "product_for_you",
          header: "Products For You",
          description: null,
          info: null,
          order: "50",
          remote: "http://104.248.163.118:8000/grandshop/featured.products/",
          more: null,
          ui_type: "ui_product_vertical",
          field_s: [],
        },
      ],
    },
    {
      section_id: "grandshop-featured-instashops",
      fieldsets: [
        {
          key: "ui_shop_insta_view",
          header: "Featured Shops",
          description: null,
          info: null,
          order: "0",
          remote: "http://104.248.163.118:8000/grandshop/featured.instashops/",
          more: null,
          ui_type: "ui_shop_insta_view",
          field_s: [],
        },
      ],
    },
  ],
  product_types: [
    {
      key: "general",
      display_name: "General",
      icon: "http://104.248.163.118:8000/media/icons/general.png",
      order: 10,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "car",
      display_name: "Car",
      icon: "http://104.248.163.118:8000/media/icons/car.png",
      order: 20,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "house",
      display_name: "House",
      icon: "http://104.248.163.118:8000/media/icons/house.png",
      order: 30,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "electronics",
      display_name: "Electronics",
      icon: "http://104.248.163.118:8000/media/icons/electronics.png",
      order: 40,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "fashion",
      display_name: "Fashion",
      icon: "http://104.248.163.118:8000/media/icons/fashion.png",
      order: 50,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "fooddrink",
      display_name: "Food And Drink",
      icon: "http://104.248.163.118:8000/media/icons/fooddrink.png",
      order: 60,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "furniture",
      display_name: "Furniture",
      icon: "http://104.248.163.118:8000/media/icons/furniture.png",
      order: 70,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
    {
      key: "healthbuety",
      display_name: "Health And Buety",
      icon: "http://104.248.163.118:8000/media/icons/healthbuety.png",
      order: 80,
      sort: [
        {
          label: "Price(low to high)",
          sortby: "price",
        },
        {
          label: "Price(High to low)",
          sortby: "-price",
        },
        {
          label: "Latest First",
          sortby: "created_at",
        },
        {
          label: "Oldest First",
          sortby: "-created_at",
        },
      ],
    },
  ],
};

const shopDetail = {
  title: "title updated ",
  description: "demo",
  latitude: 12.123,
  longtude: 11.133,
  website: "https://google.com",
  contact_username: "@Mtsige",
  telphone_contacts: {
    phonenumbers: ["+251923427836", "+251923427837"],
  },
};
const withDelay = (delay, response) => (config) => {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      resolve(response);
    }, delay);
  });
};

const getShopDetail = (delay, response) => (config) => {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      resolve(response);
    }, delay);
  });
};

mock.onGet("/api/configration").reply(withDelay(2000, [200, productConfig]));

mock.onGet("/api/shopdetail").reply(getShopDetail(5000, [200, shopDetail]));
